const {
  onlyNumericNormalize,
  zipCodeRegexNumeric,
  COMMA,
  SPACE
} = require('../helpers');

const states = {
  Alajuela: 'Alajuela',
  Cartago: 'Cartago',
  Guanacaste: 'Guanacaste',
  Heredia: 'Heredia',
  Limón: 'Limón',
  Puntarenas: 'Puntarenas',
  'San José': 'San José'
};

const stateOptions = [];
for (const key of Object.keys(states)) {
  stateOptions.push({ value: key, name: states[key] });
}

exports.zipCodeNormalize = (zipCode) => onlyNumericNormalize(zipCode, 5);

exports.countryDefinition = {
  country: 'Costa Rica',
  code: 'CR',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Street Address' },
    address2: { label: 'Street Address 2' },
    city: { label: 'City' },
    stateCode: {
      type: 'array',
      array: stateOptions,
      label: 'Province',
      width: 0.5
    },
    zipCode: {
      label: 'Postal Code',
      width: 0.5,
      normalize: exports.zipCodeNormalize
    }
  },
  states,
  viewFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['stateCode', COMMA, 'city', SPACE, 'zipCode']
  ],
  formFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['city'],
    ['zipCode', 'stateCode']
  ],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    { field: 'stateCode' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(zipCodeRegexNumeric(5)),
      error: 'Must be 5 numbers, 40501'
    }
  ]
};
